import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { EntityRoutes } from 'routes/constants';

import { PlainLink } from '../../shared';

export const JobOrderDetail = ({ item }) => {
  return (
    <Box>
      <Typography variant="subtitle1">{item.title}</Typography>
      <Typography variant="body1">{item.recruiter}</Typography>
      <Typography variant="body1">
        {item.specialty}: {item.subspecialty}
      </Typography>
      <Typography variant="body2">{item.location}</Typography>
      <PlainLink
        itemId={item.company.id}
        linkProps={{
          type: 'local',
          url: EntityRoutes.CompanyProfile,
          target: '_blank'
        }}
        aria-label="Company"
      >
        {item.company.name}
      </PlainLink>
      <div>
        <PlainLink
          itemId={item.id}
          linkProps={{
            type: 'local',
            url: EntityRoutes.JobOrderProfile,
            target: '_blank'
          }}
          aria-label="Job Order"
        >
          View Job Order
        </PlainLink>
      </div>
    </Box>
  );
};
